var _rect, _path, _path2, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_897",
    "data-name": "Ret\\xE2ngulo 897",
    width: 60,
    height: 60,
    rx: 10,
    fill: "#ccc",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar-8",
    transform: "translate(13.715 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_200-2",
    "data-name": "Line 200-2",
    transform: "translate(0.159 12.693)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    d: "M720.411,548.156H689.856a1.286,1.286,0,0,1,0-2.571h30.555a1.286,1.286,0,1,1,0,2.571Z",
    transform: "translate(-688.57 -545.585)",
    fill: "#eee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined_Shape-29",
    "data-name": "Combined Shape-29",
    transform: "translate(7.821 19.389)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    "data-name": "Caminho 358",
    d: "M709.561,558.726a1.293,1.293,0,0,1-1.294-1.286,1.28,1.28,0,0,1,1.279-1.286h.015a1.286,1.286,0,1,1,0,2.571Zm-7.6,0a1.294,1.294,0,0,1-1.294-1.286,1.279,1.279,0,0,1,1.277-1.286h.017a1.286,1.286,0,1,1,0,2.571Zm-7.625,0a1.292,1.292,0,0,1-1.293-1.286,1.279,1.279,0,0,1,1.279-1.286h.014a1.286,1.286,0,1,1,0,2.571Zm15.23-6.663a1.293,1.293,0,0,1-1.294-1.286,1.28,1.28,0,0,1,1.279-1.286h.015a1.286,1.286,0,1,1,0,2.571Zm-7.6,0a1.294,1.294,0,0,1-1.294-1.286,1.279,1.279,0,0,1,1.277-1.286h.017a1.286,1.286,0,1,1,0,2.571Zm-7.625,0a1.292,1.292,0,0,1-1.293-1.286,1.279,1.279,0,0,1,1.279-1.286h.014a1.286,1.286,0,1,1,0,2.571Z",
    transform: "translate(-693.039 -549.491)",
    fill: "#fff595"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_207-2",
    "data-name": "Line 207-2",
    transform: "translate(22.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    "data-name": "Caminho 359",
    d: "M702.807,546.394a1.286,1.286,0,0,1-1.286-1.286v-5.642a1.286,1.286,0,1,1,2.571,0v5.642A1.286,1.286,0,0,1,702.807,546.394Z",
    transform: "translate(-701.521 -538.181)",
    fill: "#eee"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line_208-2",
    "data-name": "Line 208-2",
    transform: "translate(8.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    "data-name": "Caminho 360",
    d: "M694.728,546.394a1.286,1.286,0,0,1-1.286-1.286v-5.642a1.286,1.286,0,1,1,2.571,0v5.642A1.286,1.286,0,0,1,694.728,546.394Z",
    transform: "translate(-693.442 -538.181)",
    fill: "#eee"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path-12",
    transform: "translate(0 2.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    "data-name": "Caminho 361",
    d: "M712.439,573.91h-14.5c-5.837,0-9.463-3.6-9.463-9.391V549.005c0-5.7,3.626-9.245,9.463-9.245h14.515a9.632,9.632,0,0,1,7.008,2.535,9.207,9.207,0,0,1,2.443,6.713V564.65C721.906,570.362,718.28,573.91,712.439,573.91Zm-14.5-31.579c-4.443,0-6.891,2.371-6.891,6.674v15.514c0,4.4,2.448,6.819,6.891,6.819h14.5c4.447,0,6.895-2.376,6.895-6.689V549.005a6.623,6.623,0,0,0-1.692-4.893,7.14,7.14,0,0,0-5.187-1.781Z",
    transform: "translate(-688.477 -539.76)",
    fill: "#eee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleDisabled);
export default __webpack_public_path__ + "static/media/schedule-disabled.a470c0328832764cd780ca3815294b36.svg";
export { ForwardRef as ReactComponent };